import React from "react";
import DataTable from "react-data-table-component";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { Link } from "react-router-dom";
// import { BiShow } from "react-icons/bi";
import "./style.scss";
import card_image from "../../../assets/card_image.png";

// import { Row } from "reactstrap";

const TableView = ({ currentTableData }) => {
  const enhancedData = currentTableData?.map((row) => ({
    ...row,
    categoryName: row.categoryName || "N?A",
    categoryTitle: row.categoryTitle || "צדיקים",
    categoryIcon: row.categoryIcon || { card_image },
  }));

  const customStyles = {
    tableWrapper: { style: { overflowX: "auto" } },
    table: { style: { backgroundColor: "transparent", minWidth: "1150px" } },
    headRow: {
      style: {
        height: "50px",
        borderRadius: "5px",
        borderWidth: "1px",
        border: "1px solid #81818133",
        background: "#F5F5F5",
        marginBottom: "16px",
      },
    },
    headCells: {
      style: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0%",
        color: "#494949",
        textTransform: "none",
        paddingLeft: "12px",
        paddingRight: "12px",
      },
    },
    rows: {
      style: {
        height: "80px",
        borderRadius: "3.75px",
        borderWidth: "0.7px",
        border: "0.7px solid #B1AFAD",
        borderBottom: "0.7px solid #B1AFAD !important",
        backgroundColor: "transparent",
        marginBottom: "16px",
      },
      stripedStyle: { backgroundColor: "transparent" },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(0,0,0,0.05)",
        transitionDuration: "0.25s",
        borderRadius: "3.75px",
      },
      cells: {
        style: {
          backgroundColor: "transparent",
          paddingLeft: "0px",
          paddingRight: "0px",
        },
      },
    },
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => (
        <p
          style={{
            fontFamily: "Times New Roman",
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "100%",
            letterSpacing: "0",
            verticalAlign: "middle",
            textTransform: "capitalize",
            color: "#3F3F3F",
            marginBlockEnd: "0px",
            marginBlockStart: "0px",
          }}
        >
          {row?.title}
        </p>
      ),
      sortable: true,
      className: "title-column",
      width: "40%",
    },
    {
      name: "Date",
      cell: (row) => (
        <div className="date-column">
          {row.nfDay} {row.nfMonth}, {row.nfYear}
        </div>
      ),
      width: "40%",
    },
    {
      name: "Actions",
      cell: (d) => (
        <div className="actions">
          <Link
            to={`/category-detail/?tzadikimId=${d?.id}`}
            state={{
              categoryName: d.categoryName,
              categoryTitle: d.categoryTitle,
              categoryIcon: d.categoryIcon,
            }}
            className="link_view_more"
          >
            View More
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div>
      {enhancedData?.length === 0 ? (
        <NoDataFound />
      ) : (
        <DataTable
          className="my-custom-table"
          columns={columns}
          data={enhancedData}
          customStyles={customStyles}
        />
      )}
    </div>
  );
};

export default TableView;
